import { List, ListItem } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import VideoPlayer from '../../../../components/VideoPlayer';

type Program = {
  bcast: string,
  bcasturl: string,
  benddate: string,
  bgrade: string,
  bimg: string,
  bmemo: string,
  bopen: string,
  bopendate: string,
  bstartdate: string,
  bstory: string,
  btime: string,
  btotalno: number,
  buse: string,
  bvodad_idkey: number,
  category: string,
  domain: string,
  idkey: number,
  ipaddr: string,
  lastdate: string,
  program: string,
  regdate: string,
}

type TypeProgram = {
  vodList: Array<Program>,
  currentVOD: PropTypes.object
}

const propTypes = {
  vodList: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentVOD: PropTypes.object
}

const defaultProps = {
  vodList: [],
  currentVOD: {}
}

const SERVER_IP = process.env.S3_SERVER

class VODDetail extends React.Component<TypeProgram> {
  constructor(props) {
    super(props)
    this.state = {
      vod: this.props.vodList[0]
    }
  }

  setVOD = (vod: Program) => {
    this.setState({
      vod: vod
    })
  }

  render() {
    const { vodList, currentVOD: { category } } = this.props
    const { vod: { bimg, bsubtitle, bvodfile } } = this.state
    return (
      <div className="sub-container">
        <div className="vod-container">
          <div className="video-container">
            <div className="flex--container">
              <div className="video--container--body">
                <VideoPlayer
                  poster={bimg}
                  src={`${encodeURI(SERVER_IP+bvodfile)}`}
                // controls
                />
              </div>
            </div>
          </div>
          <div className="vod-title-container">
            <div className="vod-title">
              {bsubtitle}
            </div>
            <div className="vod-series">
              {category}
            </div>
          </div>
        </div>

        <div className="vod-list-container">
          <div className="vod-list-scroll-container">
            <List className="vod-list">
              {vodList.map((vod, i) => (
                <ListItem
                  button
                  className="vod-list-item"
                  key={i}
                  onClick={() => (this.setVOD(vod))}
                >
                  {vod.bsubtitle}
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </div>
    )
  }
}

VODDetail.propTypes = propTypes
VODDetail.defaultProps = defaultProps

export default VODDetail
